import { ITaxonomyTagsContextProps } from "./TaxonomyTags.provider";

export const initialContextValue: ITaxonomyTagsContextProps = {
  selectionState: {},
  toggleSelection: () => null,
  categorizedData: {},
  searchQuery: "",
  setSearchQuery: () => null,
  top5Ela: [],
  isChecked: () => false,
  handleTopicSubmit: () => {
    return {};
  },
  setSelectionState: () => null,
  isTabletOrMobileView: false,
  prevTaxonomyQueryValue: [],
  setPrevTaxonomyQueryValue: () => null,
  setShouldUpdateTags: () => null,
  latestSavedSelectionState: null,
  setLatestSavedSelectionState: () => null,
};

export const TAXONOMY_DEPTH = 4;
export enum TaxonomyLevelEnum {
  ROOT_LEVEL = 0,
  COLLAPSE_LEVEL = 1,
  MAIN_CATEGORY_LEVEL = 2,
}

export const TAXONOMY_TOPICS_ALLOWED = [
  "ela",
  "newsela-social-studies",
  "newsela-science",
];

export const controlRemoveTaxonomyTag = "controlRemoveTaxonomyTag";
